import type { FxRatesResponse } from "./types";

async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });
  const body = (await response.json()) as T & { message?: string };
  if (!response.ok) {
    const error = new Error(
      response.status === 401
        ? "Bitte erneut anmelden."
        : "EZB-Referenzkurse konnten nicht geladen werden.",
    ) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  return body;
}

export function loadRates(): Promise<FxRatesResponse> {
  return getJson<FxRatesResponse>("/api/ecb-fx/rates");
}

export function formatRate(value: number): string {
  return value.toLocaleString("de-DE", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
}

export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}
